import styles from './InvestigationAssetActivity.module.scss';
import { useGetAssetActivityQuery } from '@customer/store/apis/assetsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import Notes from '@customer/components/data-display/notes/Notes';
import { useTranslation } from 'react-i18next';

export interface InvestigationAssetActivityProps {
  assetId?: string;
  investigationId?: number;
}

export function InvestigationAssetActivity({
  assetId,
  investigationId,
}: InvestigationAssetActivityProps) {
  const { t } = useTranslation();

  const request = investigationId && assetId ? { assetId, investigationId } : skipToken;
  const { currentData } = useGetAssetActivityQuery(request, {
    refetchOnMountOrArgChange: 10,
    skip: typeof assetId === 'undefined',
  });

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.row__label}>{t('ShowingDataFrom')}</div>
        <div className={styles.row__value}>{t('DaysPriorToInteraction', { count: 30 })}</div>
      </div>
      <div className={styles.notesContainer}>
        <Notes
          countTrans="ActivityCount"
          noneTrans="NoActivity"
          entityId={assetId}
          notes={currentData}
          hideAdd={true}
        />
      </div>
    </div>
  );
}

export default InvestigationAssetActivity;
